jQuery(document).ready(function ($) {
  const customSelects = $(".custom-select");

  // Handle dropdown visibility and interactions
  customSelects.each(function () {
    const customSelect = $(this);
    const trigger = customSelect.find(".custom-select-trigger");
    const options = customSelect.find(".custom-options");

    // Toggle dropdown visibility
    trigger.on("click", function () {
      options.toggleClass("open");
    });

    // Close dropdown when clicking outside
    $(document).on("click", function (e) {
      if (
        !customSelect.is(e.target) &&
        customSelect.has(e.target).length === 0
      ) {
        options.removeClass("open");
      }
    });

    // Update filter tags on checkbox toggle
    options.on("change", 'input[type="checkbox"]', function () {
      const checkbox = $(this);
      const filterType = checkbox.attr("name").replace("[]", "");
      const filterValue = checkbox.val();

      // Dynamically add or remove tags
      updateFilterTags(filterType, filterValue, checkbox.is(":checked"));
    });
  });

  // Reset pagination when filters are applied
  $("#programmation-filter-form").on("submit", function (e) {
    e.preventDefault(); // Prevent default form submission

    let currentUrl = window.location.href;

    // Remove pagination from the URL (i.e., `/page/2/`)
    currentUrl = currentUrl.replace(/\/page\/\d+\//, "/");

    // Extract filter parameters
    let params = new URLSearchParams($(this).serialize());

    // Update the browser's URL without pagination
    window.history.replaceState(
      {},
      "",
      currentUrl.split("?")[0] + "?" + params.toString()
    );

    // Reload the page with updated filters (resetting pagination)
    window.location.href = currentUrl.split("?")[0] + "?" + params.toString();
  });

  // Handle tag removal
  const tagsContainer = $(".filters-tags");

  // ✅ Handle Reset Filters Tag Click
  tagsContainer.on("click", "#reset-filters", function (e) {
    e.preventDefault();

    // Uncheck all checkboxes
    $('input[type="checkbox"]').prop("checked", false);

    // Remove all filter tags from the DOM
    $(".filters-tags .tag").remove();

    // Update URL by removing all filters
    let currentUrl = new URL(window.location.href);
    currentUrl.search = ""; // Clear all query parameters
    window.history.replaceState({}, "", currentUrl.toString());

    // Reload the page to reset filters
    window.location.href = currentUrl.toString();
  });

  // ✅ Handle Individual Tag Removal
  tagsContainer.on("click", ".remove-tag", function (e) {
    e.preventDefault();
    const tag = $(this).closest(".tag");
    const filterType = tag.data("key");
    const filterValue = tag.data("value");

    // Uncheck the corresponding checkbox
    const checkbox = $(`input[name="${filterType}[]"][value="${filterValue}"]`);
    if (checkbox.length) checkbox.prop("checked", false);

    // Remove the tag from the DOM
    tag.remove();

    // Update URL: Remove parameter from query string
    let currentUrl = new URL(window.location.href);
    let params = new URLSearchParams(currentUrl.search);
    let values = params.getAll(filterType);
    values = values.filter((value) => value !== filterValue);
    if (values.length > 0) {
      params.set(filterType, values.join(","));
    } else {
      params.delete(filterType);
    }

    // Update browser URL
    window.history.replaceState(
      {},
      "",
      `${currentUrl.pathname}?${params.toString()}`
    );

    // If no filters remain, hide the reset button
    if ($(".filters-tags .tag").length <= 1) {
      $("#reset-filters").remove();
    }

    // Reload page to update results
    $("#programmation-filter-form").submit();
  });

  // CSS and Animation for the filter section
  const filterToggleButton = $("#filter-toggle-button");
  const filterSection = $("#filter-section");
  const layoutIcon = $("#layout-icon");

  let isAnimating = false;

  filterToggleButton.on("click", function () {
    if (isAnimating) return;
    isAnimating = true;

    if (filterSection.hasClass("open")) {
      filterSection.css({ overflow: "hidden", maxHeight: "0px" });
      layoutIcon.css("transform", "rotate(0deg)");
      filterSection.removeClass("open");
    } else {
      filterSection.css({
        maxHeight: filterSection.prop("scrollHeight") + "px",
      });
      layoutIcon.css("transform", "rotate(45deg)");
      setTimeout(() => filterSection.css("overflow", "visible"), 300);
      filterSection.addClass("open");
    }

    setTimeout(() => {
      isAnimating = false;
    }, 300);
  });

    // Handle screen size changes
    $(window).on("resize", function () {
      const isMobile = window.innerWidth < 640; // Tailwind's `sm` breakpoint is 640px

      if (!isMobile) {
        // Reset filter section for desktop
        filterSection.css({ overflow: "visible", maxHeight: "none" });
        filterSection.addClass("open");
        layoutIcon.css("transform", "rotate(0deg)");
      } else if (!filterSection.hasClass("open")) {
        // Ensure filter section is closed on mobile if not already open
        filterSection.css({ overflow: "hidden", maxHeight: "0px" });
      }
    });

      // Trigger resize event on page load to ensure correct initial state
  $(window).trigger("resize");

  function getCurrentPage() {
    let match = window.location.pathname.match(/\/page\/(\d+)\//);
    return match ? match[1] : 1; // Default to page 1
  }

  const layoutChangeButton = $("#layout-change-button");
  const listIcon = $("#list-icon");
  const cardsIcon = $("#cards-icon");
  const eventsContainer = $("#events-container");

  let currentLayout = eventsContainer.attr("data-layout"); // Get layout from data attribute

  // Set correct icon on page load
  if (currentLayout === "card") {
    listIcon.show();
    cardsIcon.hide();
  } else {
    cardsIcon.show();
    listIcon.hide();
  }

  // Change layout and update URL
  layoutChangeButton.on("click", function (e) {
    e.preventDefault();

    // Toggle layout
    currentLayout = currentLayout === "list" ? "card" : "list";
    eventsContainer.attr("data-layout", currentLayout);

    // Toggle icons
    if (currentLayout === "card") {
      listIcon.show();
      cardsIcon.hide();
    } else {
      cardsIcon.show();
      listIcon.hide();
    }

    // Get current page
    let paged = getCurrentPage();

    fetchEvents(currentLayout, paged);
  });

  // ✅ Handle Pagination Clicks and Preserve Layout
  $(document).on("click", ".pagination a", function (e) {
    e.preventDefault();

    let paged = $(this).attr("href").match(/page\/(\d+)/);
    paged = paged ? paged[1] : 1;

    let currentLayout = eventsContainer.attr("data-layout");

    let currentUrl = new URL(window.location.href);
    currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+\//, "/") + `page/${paged}/`;
    window.history.replaceState({}, "", currentUrl.toString());

    fetchEvents(currentLayout, paged);
});

  function fetchEvents(layoutType, paged) {
    console.log("Fetching events for layout:", layoutType, "Page:", paged);

    const genre = $('input[name="genre[]"]:checked').map(function () {
        return $(this).val();
    }).get();
    const lieu = $('input[name="lieu[]"]:checked').map(function () {
        return $(this).val();
    }).get();
    const mois = $('input[name="mois[]"]:checked').map(function () {
        return $(this).val();
    }).get();
    const tarif = $('input[name="tarif[]"]:checked').map(function () {
        return $(this).val();
    }).get();

    const entity_slug = entityData?.slug || "";

    $.ajax({
        url: ajax.url,
        type: "POST",
        data: {
            action: "update_event_layout",
            layout: layoutType,
            paged: paged,
            genre: genre,
            lieu: lieu,
            mois: mois,
            tarif: tarif,
            entity: entity_slug,
        },
        beforeSend: function () {
            eventsContainer.html("<p>Loading...</p>");
        },
        success: function (response) {
            console.log("AJAX Response:", response);
            if (response.success) {
                renderEvents(response.data.html, response.data.pagination, layoutType);
            } else {
                console.error("Error fetching events:", response.data.message);
                eventsContainer.html("<p>Error loading events.</p>");
            }
        },
        error: function (xhr, status, error) {
            console.error("AJAX error:", status, error);
            eventsContainer.html("<p>Error loading events.</p>");
        },
    });
}

function renderEvents(eventsHTML, paginationHTML, layoutType) {
    eventsContainer.html(eventsHTML);
    $(".pagination").html(paginationHTML); // ✅ Update Pagination

    eventsContainer.attr("data-layout", layoutType);

    if (layoutType === "card") {
        eventsContainer
            .removeClass("flex flex-col space-y-4")
            .addClass("grid grid-cols-2 lg:grid-cols-3 gap-[10px] sm:gap-[20px] lg:gap-[30px]");
    } else {
        eventsContainer
            .removeClass("grid grid-cols-2 lg:grid-cols-3 gap-[10px] sm:gap-[20px] lg:gap-[30px]")
            .addClass("flex flex-col space-y-4");
    }
}


});
